function Homepage() {
  return <h1>Welcome to my site</h1>
}

export default Homepage
